import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { ThemeProvider as ThemeProviderStyled } from 'styled-components';
import defaultTheme from '@vr/lib/styles/theme';
import MaterialProvider, { jvcefTheme } from './MaterialProvider';
import devices from '../styles/devices';
import { setIssuer } from '~/store/modules/issuer/actions';
import { VRPAT, JVCEF } from '~/config/constants';
import { getIssuer } from '~/helpers/getIssuer';

const themes = {
  [VRPAT]: defaultTheme,
  [JVCEF]: jvcefTheme,
};

const theme = { ...themes[getIssuer()], devices };

const ThemeProvider = ({ children }) => {
  const dispatch = useDispatch();
  const issuer = getIssuer();

  useEffect(() => {
    dispatch(setIssuer(issuer));
  }, []);

  return (
    <ThemeProviderStyled theme={theme}>
      <MaterialProvider issuer={issuer}>{children}</MaterialProvider>
    </ThemeProviderStyled>
  );
};

ThemeProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
    PropTypes.object,
  ]),
};

ThemeProvider.defaultProps = {
  children: null,
};

export default ThemeProvider;
